import React from 'react';
import clsx from 'clsx';

import { Sticky as StyledSticky } from './wrappers';

interface ISticky {
  children: React.ReactNode;
  locked?: boolean;
}

const Sticky = ({ children, locked }: ISticky) => (
  <StyledSticky className={clsx(locked && 'locked')}>{children}</StyledSticky>
);

export default Sticky;
